import { render, staticRenderFns } from "./drugUAE.vue?vue&type=template&id=d2a2a048&"
import script from "./drugUAE.vue?vue&type=script&lang=js&"
export * from "./drugUAE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports